import { Typography } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '../../store/emailAndPassword/emailAndPasswordAsyncActions';
import { setLoading } from '../../store/common/commonActions';
import { useHistory } from 'react-router-dom';
import Loadingtext from '../../components/loading';
import { notification } from 'antd';
import React from 'react';

const { Title } = Typography;

const ResetPassword = () => {
    const dispatch = useDispatch();
    const Loading = useSelector((state: any) => state.common.loading);
    const loginResp = useSelector((state: any) => state.user.userSession);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const history = useHistory();

    const resetUserInformation = async () => {
        if (!loginResp) {
            dispatch(setLoading(true));
            try {
                const params = window.location.search;
                const param = new URLSearchParams(params);
                const email = param.get('email');
                const otp = param.get('otp');

                if ((email && emailRegex.test(email)) && otp) {
                    const query = { email, otp };
                    const response: any = await dispatch(resetPassword(query));

                    if (response) {
                        notification["success"]({
                            message: "SUCCESS",
                            description: response.message,
                            placement: "bottomRight"
                        })
                        history.push("/login");
                    } else {
                        history.push("/login");
                    }
                } else {
                    history.push("/login");
                }
            } catch (error) {
                dispatch(setLoading(false));
                history.push("/login");
            }
        } else {
            history.push("/login");
            dispatch(setLoading(false)); // Ensure loading state is stopped
        }
    };

    useEffect(() => {
        resetUserInformation();
    }, []); // Make sure this runs only once on mount

    return (
        <React.Fragment>
            {Loading &&
                <Loadingtext />
            }
        </React.Fragment>
    );
};

export default ResetPassword;
